// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/companies/:company_id/custom_domains" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomDomains } from "./constants";
import type { CompaniesCompanyIdCustomDomainsParams, CustomDomainTableResult } from "./types";
import { isCompaniesCompanyIdCustomDomainsGetResult } from "./validators";

export const getCompaniesCompanyIdCustomDomains = reactQueryTableFetcherAdapter(
  companiesCompanyIdCustomDomains,
  (
    signal: AbortSignal,
    {
      companyId,
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: CompaniesCompanyIdCustomDomainsParams
  ): Promise<CustomDomainTableResult> => {
    return fetch(
      `/companies/${companyId}/custom_domains`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isCompaniesCompanyIdCustomDomainsGetResult
);
